module.exports = __webpack_public_path__ + "img/mp3.eb04a0b5.svg";